module.exports = __webpack_public_path__ + "static/media/team-02.018f259b.jpeg";